import _ from 'lodash';

export class ApiManager {
  constructor(client) {
    this.client = client;
  }

  _withHeaders(headers = {}) {
    return _.merge(headers, this.client.auth.resolveAuthHeader());
  }

  async getAllTableNames() {
    try {
      const response = await this.client.axios.post('/graphql', {
        query: `{ __schema { types { kind name } } }`
      }, { headers: this._withHeaders() });

      return _(response)
        .get('data.data.__schema.types', [])
        .filter(t => t.kind === 'OBJECT' && !t.name.startsWith('__'))
        .map('name')
        .value();
    } catch (error) {
      return [];
    }
  }

  async create(table, payload) {
    return this.client.axios.post(`/items/${table}`, payload, { headers: this._withHeaders() });
  }

  async update(table, id, payload) {
    return this.client.axios.patch(`/items/${table}/${id}`, payload, { headers: this._withHeaders() });
  }

  async delete(table, id) {
    return this.client.axios.delete(`/items/${table}/${id}`, { headers: this._withHeaders() });
  }

  async executeGraphQL(query, variables = {}) {
    return this.client.axios.post('/graphql', { query, variables }, {
      headers: this._withHeaders({ 'Content-Type': 'application/json' })
    });
  }

  async withRetry(fn, maxRetries = 3, backoff = 300) {
    let lastError;
    
    for (let attempt = 0; attempt < maxRetries; attempt++) {
      try {
        return await fn();
      } catch (error) {
        lastError = error;
        if (attempt === maxRetries - 1) break;
        await new Promise(resolve => setTimeout(resolve, backoff * Math.pow(2, attempt)));
      }
    }
    
    throw lastError;
  }

  async batch(operations) {
    return Promise.all(operations.map(async operation => {
      try {
        const result = await this._executeOperation(operation);
        return { success: true, data: result };
      } catch (error) {
        return { success: false, error };
      }
    }));
  }

  async _executeOperation({ type, table, payload, id, query, variables }) {
    const actions = {
      create: () => this.create(table, payload),
      update: () => this.update(table, id, payload),
      delete: () => this.delete(table, id),
      query: () => this.executeGraphQL(query, variables)
    };
    
    if (!actions[type]) throw new Error(`Unknown operation type: ${type}`);
    return actions[type]();
  }

  async uploadFile(file, folder = null) {
    const formData = new FormData();
    formData.append('file', file);
    if (folder) formData.append('folder', folder);

    return this.client.axios.post('/files', formData, {
      headers: this._withHeaders({ 'Content-Type': 'multipart/form-data' })
    });
  }

  async ping() {
    try {
      const response = await this.client.axios.get('/server/ping');
      return response.status === 200;
    } catch (error) {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/directus-sdk/api.js